import HTTP from "@/_helpers/http";
import { PARTNERLIST__API } from "@/_helpers/urls";
import { PARTNERLIST__MUTATIONS } from "../mutation-types";
import { PARTNERLIST__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  dashboardPartnerLists: [],
  allpartnerlists: [],
  partnerlist: [],
  partnerlistCsv: [],
  totalCommission: 0,
  totalVolume: 0,
  totalChild: 0,
  clientTree: 0,
  summary: null,
  withdrawals: null,
  advancedrates: null,
  advancedratescomtree: null,
  dashboardibrequest: [],
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  },
  //commission history tab data
  commissionhistory: null,
  commissionhistorypagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  },
  commissionhistoryBusinessLevel: 0,
  commissionhistoryTotalCommission: 0,
  commissionhistoryTotalLot: 0,
  commissionhistoryTotaltrade: 0,
};

// Getters
const getters = {};

// Mutations
const mutations = {
  [PARTNERLIST__MUTATIONS.WITHDRAWALS](state, data) {
    state.withdrawals = data;
  },
  [PARTNERLIST__MUTATIONS.ADVANCEDRATES](state, data) {
    state.advancedrates = data.data;
  },
  [PARTNERLIST__MUTATIONS.ADVANCEDRATESCOMMISSIONTREE](state, data) {
    state.advancedratescomtree = data;
  },
  [PARTNERLIST__MUTATIONS.CLIENTTREE](state, data) {
    state.clientTree = data.clientTree;
  },

  [PARTNERLIST__MUTATIONS.COMMISSIONHISTORY](state, data) {
    state.commissionhistory = Array.isArray(data?.data?.summaries) ? data.data.summaries : [];
    state.commissionhistorypagination = data?.data?.pagination;
    state.commissionhistoryTotalCommission = data?.data?.totalCommission;
    state.commissionhistoryTotalLot = data?.data?.totalLot;
    state.commissionhistoryTotaltrade = data?.data?.totaltrade;
    state.commissionhistoryBusinessLevel = data?.data?.businessLevel;
  },

  [PARTNERLIST__MUTATIONS.PARTNERSUMMARY](state, data) {
    state.summary = data.data.details;
  },

  [PARTNERLIST__MUTATIONS.ALLPARTNERLIST](state, data) {
    state.allpartnerlists = data;
  },

  [PARTNERLIST__MUTATIONS.DASHBOARDPARTNERLISTS](state, data) {
    state.dashboardPartnerLists = data;
  },
  [PARTNERLIST__MUTATIONS.DASHBOARDIBREQUEST](state, data) {
    state.dashboardibrequest = data;
  },

  [PARTNERLIST__MUTATIONS.PARTNERLIST](state, data) {
    state.partnerlist = data.partnerLists;
    state.totalCommission = data.totalCommission;
    state.totalVolume = data.totalVolume;
    state.totalChild = data.totalChild;
    state.pagination = data.pagination;
  }
};

// Actions
const actions = {
  async [PARTNERLIST__ACTIONS.ADDCLIENTLEVELONE]({ commit, state, dispatch }, data) {
    try {
      const response = await HTTP().post(
        PARTNERLIST__API.ADDCLIENTLEVELONE, data
      );

      dispatch(PARTNERLIST__ACTIONS.CLIENTTREE, { partner_id: data?.parent_ib });
      toast.success(response.data.message)
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message || 'Failed to update')
    }
  },
  async [PARTNERLIST__ACTIONS.DASHBOARDIBREQUEST]({ commit, state }) {
    try {
      const response = await HTTP().get(
        PARTNERLIST__API.DASHBOARDIBREQUEST
      );
      commit(PARTNERLIST__MUTATIONS.DASHBOARDIBREQUEST, response.data);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message || 'Failed to update')
    }
  },
  async [PARTNERLIST__ACTIONS.UPDATECOMMISSIONRATES]({ commit, state, dispatch }, data) {
    try {
      const response = await HTTP().post(
        `${PARTNERLIST__API.UPDATECOMMISSIONRATES}?partner_id=${data?.partner_id}`, {
        total_ib_levels: data.total_ib_levels,
        account_type: data.account_type,
        currency_group: data.currency_group,
        totalCommission: data.totalCommission,
        commissionRates: data.commissionRates,
      }
      );

      dispatch(PARTNERLIST__ACTIONS.ADVANCEDRATES, { partner_id: data?.partner_id });
      toast.success(response.data.message)
    } catch (error) {
      console.log(error);
      toast.error('Failed to update')
    }
  },
  async [PARTNERLIST__ACTIONS.ALLPARTNERLIST]({ commit, state }) {
    try {
      const response = await HTTP().get(PARTNERLIST__API.ALLPARTNERLIST);

      if (response.status === 200) {
        commit(PARTNERLIST__MUTATIONS.ALLPARTNERLIST, response.data);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async [PARTNERLIST__ACTIONS.DASHBOARDPARTNERLISTS]({ commit, state }) {
    try {
      const response = await HTTP().get(PARTNERLIST__API.DASHBOARDPARTNERLISTS);

      if (response.status === 200) {
        commit(PARTNERLIST__MUTATIONS.DASHBOARDPARTNERLISTS, response.data);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async [PARTNERLIST__ACTIONS.UPDATECOMMISSIONSTATUS]({ commit, state, dispatch }, parameter) {
    try {
      const new_statusParam =
        parameter?.new_status != null ? `new_status=${parameter.new_status}` : "";

      const partner_idParam =
        parameter?.partner_id != null ? `partner_id=${parameter.partner_id}` : "";

      const parameterString = [new_statusParam, partner_idParam]
        .filter((param) => param !== "")
        .join("&");

      const response = await HTTP().put(
        PARTNERLIST__API.UPDATECOMMISSIONSTATUS +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      if (response.status === 200) {
        toast.success(response.data.message || "Updated successfully")
        //dispatch(PARTNERLIST__ACTIONS.PARTNERLIST, response.data);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message || "Failed to update")
    }
  },
  async [PARTNERLIST__ACTIONS.ADVANCEDRATESCOMMISSIONTREE]({ commit, state }, parameter) {
    try {
      const account_typeParam =
        parameter?.account_type != null ? `account_type=${parameter.account_type}` : "";

      const currency_groupParam =
        parameter?.currency_group != null ? `currency_group=${parameter.currency_group}` : "";

      const partner_idParam =
        parameter?.partner_id != null ? `partner_id=${parameter.partner_id}` : "";

      const parameterString = [account_typeParam, currency_groupParam, partner_idParam]
        .filter((param) => param !== "")
        .join("&");

      const response = await HTTP().get(
        PARTNERLIST__API.ADVANCEDRATESCOMMISSIONTREE +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      if (response.status === 200) {
        commit(PARTNERLIST__MUTATIONS.ADVANCEDRATESCOMMISSIONTREE, response.data);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async [PARTNERLIST__ACTIONS.ADVANCEDRATES]({ commit, state }, parameter) {
    try {
      const account_typeParam =
        parameter?.account_type != null ? `account_type=${parameter.account_type}` : "";

      const currency_groupParam =
        parameter?.currency_group != null ? `currency_group=${parameter.currency_group}` : "";

      const partner_idParam =
        parameter?.partner_id != null ? `partner_id=${parameter.partner_id}` : "";

      const parameterString = [account_typeParam, currency_groupParam, partner_idParam]
        .filter((param) => param !== "")
        .join("&");

      const response = await HTTP().get(
        PARTNERLIST__API.ADVANCEDRATES +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      if (response.status === 200) {
        commit(PARTNERLIST__MUTATIONS.ADVANCEDRATES, response.data);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async [PARTNERLIST__ACTIONS.WITHDRAWALS]({ commit, state }, parameter) {
    try {
      const durationParam =
        parameter?.duration != null ? `duration=${parameter.duration}` : "";

      const partner_idParam =
        parameter?.partner_id != null ? `partner_id=${parameter.partner_id}` : "";

      const parameterString = [durationParam, partner_idParam]
        .filter((param) => param !== "")
        .join("&");

      const response = await HTTP().get(
        PARTNERLIST__API.WITHDRAWALS +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      if (response.status === 200) {
        commit(PARTNERLIST__MUTATIONS.WITHDRAWALS, response.data);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [PARTNERLIST__ACTIONS.COMMISSIONHISTORY]({ commit, state }, parameter = {}) {
    try {
      const {
        level,
        parent_ib,
        duration,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(level && { level }),
        ...(parent_ib && { parent_ib }),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${PARTNERLIST__API.COMMISSIONHISTORY}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(PARTNERLIST__MUTATIONS.COMMISSIONHISTORY, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [PARTNERLIST__ACTIONS.PARTNERSUMMARY]({ commit, state }, parameter) {
    try {
      const partner_idParam =
        parameter?.partner_id != null ? `partner_id=${parameter.partner_id}` : "";

      const parameterString = [partner_idParam]
        .filter((param) => param !== "")
        .join("&");

      const response = await HTTP().get(
        PARTNERLIST__API.PARTNERSUMMARY +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      if (response.status === 200) {
        commit(PARTNERLIST__MUTATIONS.PARTNERSUMMARY, response.data);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async [PARTNERLIST__ACTIONS.CLIENTTREE]({ commit, state }, parameter) {
    try {
      const partner_idParam =
        parameter?.partner_id != null ? `partner_id=${parameter.partner_id}` : "";

      const levelParam =
        parameter?.level != null ? `level=${parameter.level}` : "";

      const parameterString = [levelParam, partner_idParam]
        .filter((param) => param !== "")
        .join("&");

      const response = await HTTP().get(
        PARTNERLIST__API.CLIENTTREE +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      if (response.status === 200) {
        commit(PARTNERLIST__MUTATIONS.CLIENTTREE, response.data);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async [PARTNERLIST__ACTIONS.PARTNERLIST]({ commit, state }, parameter = {}) {
    try {
      const { duration, page = 1, limit = 10, search = "" } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${PARTNERLIST__API.PARTNERLIST}?${queryParams}`
      );

      if (response.status === 200) {
        commit(PARTNERLIST__MUTATIONS.PARTNERLIST, response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async [PARTNERLIST__ACTIONS.IBWITHDRAWAL]({ commit, state, dispatch }, data) {
    try {
      const response = await HTTP().post(PARTNERLIST__API.IBWITHDRAWAL, data);
      //dispatch(PARTNERLIST__ACTIONS.WITHDRAWALS, { partner_id: data?.client_account_id });
      toast.success(response.data.message)
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message || 'Failed to update')
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
